module.exports = __webpack_public_path__ + "static/images/chart-blue.56468112c7ed0a567a9c5ecb9b34076e.svg";